<template>
  <fragment>
    <g
      id="Cheek_A-3-1-12-2"
      v-if="data.value === 'type-12' && data.position === 'm'"
    >
      <g id="cheek-10">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_80-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_80-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-11-2"
      v-if="data.value === 'type-11' && data.position === 'm'"
    >
      <g id="cheek-11">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_73-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_73-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-10-2"
      v-if="data.value === 'type-10' && data.position === 'm'"
    >
      <g id="cheek-12">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_68-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_68-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-9-2"
      v-if="data.value === 'type-9' && data.position === 'm'"
    >
      <g id="cheek-13">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_64-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_64-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-8-2"
      v-if="data.value === 'type-8' && data.position === 'm'"
    >
      <g id="cheek-14">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_59-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_59-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-7-2"
      v-if="data.value === 'type-7' && data.position === 'm'"
    >
      <g id="cheek-15">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_53-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_53-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-6-2"
      v-if="data.value === 'type-6' && data.position === 'm'"
    >
      <g id="cheek-16">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_37-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_37-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-5-2"
      v-if="data.value === 'type-5' && data.position === 'm'"
    >
      <g id="cheek-17">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_35-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_35-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-4-2"
      v-if="data.value === 'type-4' && data.position === 'm'"
    >
      <g id="cheek-18">
        <ellipse
          cx="203.61"
          cy="189.58"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_nihongo_34-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.56"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.08 255.55) rotate(-75.73)"
          fill="url(#_nihongo_34-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-3-2"
      v-if="data.value === 'type-3' && data.position === 'm'"
    >
      <g id="work-3">
        <ellipse
          cx="203.61"
          cy="189.6"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_gradient_95-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.58"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.1 255.57) rotate(-75.73)"
          fill="url(#_gradient_95-4)"
        />
      </g>
    </g>
    <g
      id="Cheek_A-3-1-2-2"
      v-if="data.value === 'type-2' && data.position === 'm'"
    >
      <ellipse
        cx="203.61"
        cy="189.58"
        rx="20.79"
        ry="18.26"
        transform="translate(-40.44 56.02) rotate(-14.27)"
        fill="url(#_gradient_214-3)"
      />
      <ellipse
        cx="116.29"
        cy="189.56"
        rx="18.26"
        ry="20.86"
        transform="translate(-96.08 255.55) rotate(-75.73)"
        fill="url(#_gradient_214-4)"
      />
    </g>
    <g
      id="Cheek_A-3-1-1-2"
      v-if="data.value === 'type-1' && data.position === 'm'"
    >
      <g id="work-4">
        <ellipse
          cx="203.61"
          cy="189.6"
          rx="20.79"
          ry="18.26"
          transform="translate(-40.44 56.02) rotate(-14.27)"
          fill="url(#_gradient_20-3)"
        />
        <ellipse
          cx="116.29"
          cy="189.58"
          rx="18.26"
          ry="20.86"
          transform="translate(-96.1 255.57) rotate(-75.73)"
          fill="url(#_gradient_20-4)"
        />
      </g>
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarCheekB',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
